module.exports = __webpack_public_path__ + "img/yidong_management.3f205b40.jpg";